import { render, staticRenderFns } from "./ElementsTextToolbar.vue?vue&type=template&id=2458e54a"
import script from "./ElementsTextToolbar.vue?vue&type=script&lang=js"
export * from "./ElementsTextToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports